import React from 'react';
import CommentWidget from './components/commentWidget';

function App() {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <CommentWidget />
    </div>
  );
}

export default App;